import React from "react";
import Table from "react-bootstrap/Table";
import ListHeader from "../tableLists/ListHeader";

function TableInput(props) {
    return (
        <Table responsive striped bordered hover>
            <ListHeader headers={[...props.headers, 'Akcie']}/>
            <tbody>
            {props.children}
            </tbody>
        </Table>
    )
}

export default TableInput
